<template>
  <div :class="{my: isMyMessage}" style="display: flex; flex-direction: column;">
    <slot/>
    <div class="header-message">
      {{ senderName }}
    </div>
    <div @contextmenu.prevent="$refs.menuMessage.open" class="block-message" v-html="message.message">

    </div>
    <div class="menu-message" v-if="isMyMessage || isRoleAdministrator">
      <vue-context ref="menuMessage"
                   :lazy="true"
                   :close-on-click="true"
                   :close-on-click-outside="true"
                   :closeOnScroll="true">
        <template slot-scope="item">
          <b-button-toolbar key-nav>
            <b-button-group vertical>
              <!--              <b-button class="text-left font-12 font-inter&#45;&#45;semibold" variant="outline-primary" block>-->
              <!--                Star-->
              <!--              </b-button>-->
              <!--              <b-button class="text-left font-12 font-inter&#45;&#45;semibold" variant="outline-primary" block>-->
              <!--                Copy-->
              <!--              </b-button>-->
              <b-button
                  @click="deleteMessage"
                  class="text-left font-12 font-inter--semibold"
                  variant="outline-primary"
                  block>
                Delete
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </template>
      </vue-context>
    </div>
    <div class="message-time">{{ message.createdOn | formatTime }}</div>
  </div>
</template>

<script>
import AssignTo from '@/components/assign-to.vue'
import limitedInput from '@/components/limitedInput.vue'
import { VueContext } from 'vue-context'
import { mapGetters } from 'vuex'

export default {
  name: 'chat-message',
  props: {
    message: null,
    senderName: '',
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      currentCompany: 'currentCompany/getDetails',
      currentUserId: 'currentUser/getId',
      isRoleAdministrator: 'currentUser/isAdministrator',
    }),
    isMyMessage () {
      // if (this.isUserTypeSupplier && this.isMultipleLocations) {
      //   return _.find(this.getterSettings.multipleBrands, (b) => {
      //     return Number(this.message.companyId) === Number(b.id)
      //   })
      // }
      if (this.message.type === 'InternalRfqMsg') {
        return Number(this.message.senderId) === Number(this.currentUserId)
      }
      return Number(this.message.companyId) === Number(this.currentCompany.id)
    }
  },
  methods: {
    deleteMessage () {
      this.$store.dispatch('chats/sendDeleteMessage', this.message.mainId)
    }
  },
  components: { VueContext, limitedInput, AssignTo },
}
</script>

<style scoped>
.block-message >>> .mention,
mark.mention {
  background-color: transparent;
  color: #ffffff;
  font-weight: bold;
}

.my .block-message >>> .mention,
.my mark.mention {
  color: #29babf;
}

.menu-message >>> .v-context {
  width: 120px;
}

.menu-message >>> .btn-group-vertical {
  width: 120px;
}

.menu-message >>> .btn-group-vertical .btn {
  border: 0;
  font-weight: 500 !important;
}

.menu-message >>> .btn-group-vertical .btn:hover {
  background-color: #ceeeef;
  color: #020202;
}

.menu-message >>> .btn-group-vertical .btn:last-child:hover {
  color: #fa2727;
}

.header-message {
  font-size: 12px;
  font-weight: 700;
  width: 100%;
}

.my .header-message {
  align-self: flex-end;
  text-align: right;
}

.block-message {
  width: 70%;
  border: 2px solid rgb(20, 178, 185);
  margin-bottom: 3px;
  background-color: #14b3ba;
  border-radius: 5px;
  color: #f1f9fa;
  padding: 10px;
}

.my .block-message {
  width: 70%;
  background-color: #fdfdfd;
  color: #3f3f3f;
  margin-bottom: 3px;
  border-radius: 5px;
  border: 2px solid rgba(27, 30, 56, 0.12);
  align-self: flex-end;
  padding: 10px;
}

.message-time {
  font-size: 11px;
  margin-bottom: 13px;
  padding-left: 0%;
}

.my .message-time {
  padding-left: 0%;
  text-align: right;
}
</style>
